// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".billing-summary[data-v-e8837522] {\n  border: 1px solid #e8eef1;\n  color: #003545;\n}", ""]);
// Exports
module.exports = exports;
